$(function() {
  // console.log('common.js');


  // console.log(sessionStorage.getItem('disp_first'));

  if( !sessionStorage.getItem('disp_first') ) {
    sessionStorage.setItem('disp_first', 'on');
    
    $('.first-user-modal').show();
    
  }

  // session を削除
  // sessionStorage.removeItem('disp_first');
  

  // js-modal-close をクリックしたら js-modal を閉じる
  $('.js-modal-close').on('click', function(e) {
    e.preventDefault();
    $('.js-modal').removeClass('is-open');
    $('.js-modal-yt').html('');
  });

  // js-modal-open をクリックしたら js-modal を開く、js-modal-yt に data-movie の値でyoutubeを埋め込む
  $('.js-modal-open').on('click', function(e) {
    e.preventDefault();
    const movie = $(this).data('movie');
    $('.js-modal-yt').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + movie + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
    $('.js-modal').addClass('is-open');
  });

  // js-gnavTrg をクリックしたら js-gnav を開く
  $('.js-gnavTrg').on('click', function(e) {
    e.preventDefault();

    $('.js-gnav').addClass('is-open');
  });

  // js-gnavClose をクリックしたら js-gnav を閉じる
  $('.js-gnavClose').on('click', function(e) {
    e.preventDefault();
    $('.js-gnav').removeClass('is-open');
  });
  $('.js-gnav a').on('click', function(e) {
    $('.js-gnav').removeClass('is-open');
  });


  // .js-anchor をクリックしたら指定の位置までスクロール
  $('.js-anchor').on('click', function(e) {
    e.preventDefault();
    const target = $(this).attr('href');
    const position = $(target).offset().top;
    const headerHeight = $('.c-header').outerHeight();
    const speed = 500;
    $('html, body').animate({scrollTop: position - headerHeight}, speed);

  });

  // .iconmeta > .time > time を年月日からピリオドつなぎに変換
  $('.iconmeta > .time > time').each(function() {
    const date = $(this).text();
    const dateArray = date.split('-');
    const newDate = dateArray.join('.');
    $(this).text(newDate);
  });

  // ページをスクロールしたら .c-header に .is-scroll を追加
  $(window).on('scroll', function() {
    const scroll = $(window).scrollTop();
    const headerHeight = $('.c-header').outerHeight();
    if (scroll > headerHeight) {
      $('.c-header').addClass('is-scroll');
    } else {
      $('.c-header').removeClass('is-scroll');
    }
  });

  // .about-kouji までスクロールしたら.js-character-baroon に .is-show を追加
  $(window).on('scroll', function() {

    // $('.about-kouji') が存在するか確認
    if ($('.about-kouji').length) {
      const scroll = $(window).scrollTop();
      const baroonPos = $('.about-kouji').offset().top;
      const baroonHeight = $('.about-kouji').outerHeight();
      const baroonPos2 = baroonPos + baroonHeight;
      const windowHeight = $(window).height();
      const footerPos = $('.c-footer').offset().top;

      if (scroll > baroonPos2 - windowHeight) {
        $('.js-character-baroon').addClass('is-show');

        // .c-footer までスクロールしたら .js-character-baroon に .is-show を削除
        if (scroll > footerPos - windowHeight) {
          $('.js-character-baroon').removeClass('is-show');
        }

      } else {
        $('.js-character-baroon').removeClass('is-show');
      }
    }

  });


  // .product-list__item > .product-list__info > .name のテキストが はじめてセット だったら .product-list__item に .is-special を追加
  $('.product-list__item > .product-list__info > .name').each(function() {
    const name = $(this).text();
    if (name === 'はじめてセット') {
      $(this).parent().parent().addClass('is-special');
    }
  });


  // product-tags__title から「3個セット」という文字列を削除
  $('.product-tags__title').each(function() {
    const title = $(this).text();
    const newTitle = title.replace('３個セット', '');
    $(this).text(newTitle);
  });


  // urlに#contact_form があったら .contact-summary と　.c-contact-form を非表示
  if (window.location.hash === '#contact_form') {
    $('.contact-summary').html('お問い合わせありがとうございました。<br>確認後、改めてご連絡させていただきますのでいましばらくお待ちください。<br><br>※1週間経っても連絡がない場合は、恐れ入りますが再度ご連絡いただけますと幸いです。<br>※LINE公式アカウントからもご連絡いただけます。下記リンクよりお友達追加のうえ、メッセージをお送りください。<br><a href="https://line.me/R/ti/p/@283nbnvx?oat__id=4471174" taraget="_blank">https://line.me/R/ti/p/@283nbnvx?oat__id=4471174</a>');
    $('.c-contact-form').hide();
  }


  // option-selector__btns があるか確かめる
  if ($('.option-selector__btns').length) {
    // option-selector__btns の中の a をクリックしたら、.option-selector__btns に .is-active を追加
    // console.log('option-selector__btns がある');

    // option-selector__btns の 前に .option-selector__btns-show というdiv を追加
    $('.option-selector__btns').before('<div class="option-selector__btns-show"><span class="option-selector__btns-show-text">種類を選択する</span><i class="icon-arrow-down"></i></div>');

    // option-selector__btns の input の checked の値を取得して、.option-selector__btns-show-text に表示する、読み込み時とクリック時に
    function updateOptionText() {
      let optionText = '';
      $('.option-selector__btns input:checked').each(function() {
        const label = $(this).next('label').text();
        optionText += label + ' ';
      });

      if( optionText === '') {
        optionText = '種類を選択する';
      } else {
        optionText = optionText;
      }

      $('.option-selector__btns-show-text').text(optionText.trim());
    }
    updateOptionText();

    // updateOptionText(); を あたいの変更時に実行
    $('.option-selector__btns input').on('change', function() {
      updateOptionText();
    });

    // .option-selector__btns-show をクリックしたら、.option-selector__btns に .is-active を追加
    $('.option-selector__btns-show').on('click', function() {
      if ($(this).hasClass('is-active')) {
        $(this).removeClass('is-active');
        $('.option-selector__btns').removeClass('is-active');
      } else {
        $(this).addClass('is-active');
        $('.option-selector__btns').addClass('is-active');
      }
    });


  }
  

  // ページにjs-subscription-checkがあったら .price-container に .m-subscription を追加
  if ($('.js-subscription-check').length) {
    $('.price-container').addClass('m-subscription');

    // .price__current に　"〜" を追加
    // $('.price__current').each(function() {
    //   const currentPrice = $(this).text();
    //   const newPrice = currentPrice + '〜';
    //   $(this).text(newPrice);
    // });

    $('.slider__grid').each(function() {
      // is-type-2 を追加
      $(this).addClass('is-type-2');
    });

    var count = 0;
    $('.product-form .label').each(function() {
      // <p class="subscription-select-head">種類と購入プランをお選びください</p> を先頭に追加
      // 1回だけ追加して止める
      count++;
      if (count > 1) {
        return false; // ループを抜ける
      }
      // console.log('subscription-select-head を追加');  
      $(this).prepend('<p class="subscription-select-head">種類と購入プランをお選びください</p>');
    });


    // .product-title に おトクな定期便セット（３個プラン） が含まれていたら 以下を表示
    $('.product-title').each(function() {
      const title = $(this).text();
      if (title.includes('おトクな定期便セット（３個プラン）')) {
        $('.product-description').append('<p class="c-under-line-title">おトクな定期便の他プランはこちら</p><ul class="c-sub-list"><li><a href="/products/subscription_6">６個プラン</a></li><li><a href="subscription_9">９個プラン</a></li><li><a href="subscription_12">１２個プラン</a></li></ul>');
      } else if (title.includes('おトクな定期便セット（６個プラン）')) {
        $('.product-description').append('<p class="c-under-line-title">おトクな定期便の他プランはこちら</p><ul class="c-sub-list"><li><a href="/products/subscription_3">３個プラン</a></li><li><a href="subscription_9">９個プラン</a></li><li><a href="subscription_12">１２個プラン</a></li></ul>');
      } else if (title.includes('おトクな定期便セット（９個プラン）')) {
        $('.product-description').append('<p class="c-under-line-title">おトクな定期便の他プランはこちら</p><ul class="c-sub-list"><li><a href="/products/subscription_3">３個プラン</a></li><li><a href="subscription_6">６個プラン</a></li><li><a href="subscription_12">１２個プラン</a></li></ul>');
      } else if (title.includes('おトクな定期便セット（１２個プラン）') || title.includes('おトクな定期便セット（12個プラン）')) {
        $('.product-description').append('<p class="c-under-line-title">おトクな定期便の他プランはこちら</p><ul class="c-sub-list"><li><a href="/products/subscription_3">３個プラン</a></li><li><a href="subscription_6">６個プラン</a></li><li><a href="subscription_9">９個プラン</a></li></ul>');
      }
    });
  }

});


const mvSwiper = new Swiper('.js-product-swiper', {
  // Optional parameters
  loop: true,
  // effect: 'fade',
  slidesPerView: 2,
  spaceBetween: 0,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // レスポンシブブレイクポイント（画面幅によってスライド数を変える）
  breakpoints: {
    768: {
      slidesPerView: 3,
      pagination: false,
    }
  }
});
const mvSwiper2 = new Swiper('.js-product-triple-swiper', {
  // Optional parameters
  loop: true,
  // effect: 'fade',
  slidesPerView: 2,
  spaceBetween: 0,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // レスポンシブブレイクポイント（画面幅によってスライド数を変える）
  breakpoints: {
    768: {
      slidesPerView: 3,
      pagination: false,
    }
  }
});


// urlが https://ko-jiro.com/products/ 配下か、https://ko-jiro.com/collections/ 配下だった時に https://ko-jiro.com/ にリダイレクトさせる vanilla js

const url = window.location.href;
const redirectUrl = 'https://ko-jiro.com/';
const redirectUrl2 = 'https://ko-jiro.com/products/';
const redirectUrl3 = 'https://ko-jiro.com/collections/';

if (url === redirectUrl2 || url.startsWith(redirectUrl3) || url.startsWith(redirectUrl3 + '/')) {
  window.location.href = redirectUrl;
}